/**
 * Browser stand-in for mongoose, aliased in the bundler config.
 *
 * mongoose 9 ships no browser build, so bundling the real package pulls the Node driver into the app
 * (and `stream` is empty in the browser, so the driver throws when it loads). In the browser
 * sonata-static-storage only builds schema definitions and the app only generates ObjectIds,
 * which is all this covers.
 */

const OBJECT_ID_PATTERN = /^[0-9a-f]{24}$/i;

const toHex = (value: number, bytes: number) => value.toString(16).padStart(bytes * 2, '0');
const randomHex = (bytes: number) =>
  Array.from({ length: bytes }, () => toHex(Math.floor(Math.random() * 256), 1)).join('');

// ObjectId layout: 4 bytes of seconds since epoch, 5 random bytes fixed per page load, 3 bytes counter
const processUnique = randomHex(5);
let counter = Math.floor(Math.random() * 0x1000000);

class ObjectId {
  private readonly hex: string;

  constructor(id?: string | ObjectId) {
    const value = id === undefined ? ObjectId.generate() : String(id);
    if (!OBJECT_ID_PATTERN.test(value)) {
      throw new Error(`Invalid ObjectId: ${value}`);
    }
    this.hex = value.toLowerCase();
  }

  private static generate() {
    counter = (counter + 1) % 0x1000000;
    return toHex(Math.floor(Date.now() / 1000), 4) + processUnique + toHex(counter, 3);
  }

  toHexString() {
    return this.hex;
  }

  toString() {
    return this.hex;
  }

  toJSON() {
    return this.hex;
  }
}

class SchemaBoolean {}
class SchemaMixed {}
class SchemaObjectId {}
class SchemaString {}

class Schema {
  static Types = { Boolean: SchemaBoolean, Mixed: SchemaMixed, ObjectId: SchemaObjectId, String: SchemaString };

  readonly obj: Record<string, unknown>;

  constructor(definition: Record<string, unknown> = {}) {
    this.obj = definition;
  }

  add(definition: Record<string, unknown>) {
    Object.assign(this.obj, definition);
    return this;
  }

  index() {
    return this;
  }

  pre() {
    return this;
  }

  path() {
    return { discriminator: () => undefined };
  }
}

const Types = { ObjectId };

export { Schema, Types };
export default { Schema, Types };
